export default __webpack_public_path__ + "static/media/confirm.53f448ad.png";